@import (reference) '../../../../../constants/spacing.module.less';

.notes-section-content {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  justify-content: center;
  gap: @space-8;

  padding: @space-0 @space-16 @space-16;
}

.note-label {
  color: var(--default--text-color--17);
}

.note-input {
  margin: 0;
  min-height: 40px;
  height: 100%;
}
